interface CurrencyInfo {
  currency: string;
  symbol: string;
  price: number;
}

export const CurrencyData: Record<string, CurrencyInfo> = {
  ['en']: { currency: 'USD', symbol: '$', price: 1.19 },
  ['ja']: { currency: 'JPY', symbol: 'JP¥', price: 119 },
  ['ko']: { currency: 'KRW', symbol: '₩', price: 1099 },
  ['th']: { currency: 'THB', symbol: '฿', price: 25.99 },
};

// 定义获取 CurrencyInfo 的函数
export function getCurrencyInfo(lang: string): CurrencyInfo {
  // 尝试获取对应的 CurrencyInfo，如果没有找到则返回默认值
  return CurrencyData[lang] || CurrencyData['en'];
}

export const CurrencyMap: Record<string, CurrencyInfo> = {
  ['USD']: { currency: 'USD', symbol: '$', price: 1.19 },
  ['JPY']: { currency: 'JPY', symbol: 'JP¥', price: 119 },
  ['KRW']: { currency: 'KRW', symbol: '₩', price: 1099 },
  ['THB']: { currency: 'THB', symbol: '฿', price: 25.99 },
};
